var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"box-sizing":"border-box","margin":"10px 0","width":"calc((100% - 100px)/4)","height":"300px","background-color":"#FFFFFF","padding":"20px 0 0","border-radius":"10px"},attrs:{"id":_vm.chart.idName}})
}
var staticRenderFns = []

export { render, staticRenderFns }